import {useParams} from "react-router-dom";
import {green} from "../../Utils/style";
import {useState} from "react";
import {Container, Tabs, Tab, Box, Typography, TextField, Button, Grid} from '@mui/material';
import {WordPressToolsTracking} from "./WordPressToolsTracking";
import {getI18nContent} from "../../config/i18nConfig";
import {WordPressToolsOneTimeCode} from "./WordPressToolsOneTimeCode";
import {useIframeResizer} from "../../Utils/Helper";
import {WordPressToolsMoving} from "./WordPressToolsMoving";

export const WordPressTools = () => {

    useIframeResizer();

    const {lng} = useParams();
    const uiText = getI18nContent(lng, 'LTLTools');

    const [activeTab, setActiveTab] = useState(1);

    const handleTabChange = (event, newValue) => {
        if (typeof newValue !== 'number') return;

        setActiveTab(newValue);

    };

    console.log('[WordPressTools] activeTab', activeTab);

    return (
        <Container maxWidth='xl'>
            <Box sx={{
                display: 'flex',
                padding: '40px 0px'
            }}>
                <Box sx={{
                    border: `10px solid ${green}`,
                    borderRadius: '10px',
                    padding: '20px',
                    width: '100%',
                    minHeight: activeTab === 0 ? '400px' : '200px'
                }}>
                    <Grid container spacing={2}>
                        <Grid size={{xs: 12}}>
                            <Tabs value={activeTab} onChange={handleTabChange} centered>
                                <Tab label={uiText.tabs.moving} value={1}/>
                                <Tab label={uiText.tabs.tracking} value={0}/>
                                <Tab label={uiText.tabs.consignee} value={2}/>
                            </Tabs>
                        </Grid>
                        <Grid size={{xs: 12}}>
                            {
                                activeTab === 0 ?
                                    <WordPressToolsTracking/> :
                                    activeTab === 1 ?
                                        <WordPressToolsMoving/> :
                                        <WordPressToolsOneTimeCode/>
                            }
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Container>
    )
}